import { render, staticRenderFns } from "./SfxIconArrowLeft.vue?vue&type=template&id=6a8a9742&"
import script from "./SfxIconArrowLeft.vue?vue&type=script&lang=js&"
export * from "./SfxIconArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports